var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import React, { Component } from 'react'; // import PropTypes from 'prop-types';

import { forIn, map, assign, cloneDeep, get } from 'lodash';
import { Form as AntForm, Spin as AntSpin, Row as AntRow, Col as AntCol } from 'antd';
import { Button } from '../button';
import { TypesManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core'; // import './index.scss';
// 栅格总列数

var GRID_COLUMN_NUMBER = 24;
/**
 * 根据属性路径获取表单域
 * @param path 属性路径
 * @param fields 顶级表单域结构
 */

export function getField(path, fields) {
  var propertyNames = path.split('.');
  var field;
  var fieldName = [];

  for (var _i = 0, propertyNames_1 = propertyNames; _i < propertyNames_1.length; _i++) {
    var name_1 = propertyNames_1[_i];
    fieldName.push(name_1);
    field = fields[fieldName.join('.')];

    if (!field) {
      break;
    }

    fields = field.fields;
  }

  return field;
}
/**
 * 负责对接 Ant.Design 的表单组件
 */

var BasicForm = function (_super) {
  __extends(BasicForm, _super); // FIXME:
  // propTypes 会导致 Form.Create() 时验证冲突，先干掉
  // static propTypes = {
  //     ...basicPropTypes,
  //     // 表单域数据
  //     fields: PropTypes.object,
  //     // 表单域修改事件
  //     onFieldChange: PropTypes.func,
  //     // 表单提交事件（该事件将在点击提交按钮并校验完成后触发）
  //     onSubmit: PropTypes.func,
  //     // 表单布局
  //     direction: PropTypes.oneOf(['horizontal', 'vertical', 'inline']),
  //     // 表单域容器布局配置对象
  //     fieldRow: PropTypes.object,
  //     // 表单域宽度配置对象
  //     fieldCol: PropTypes.object,
  //     // 定义 label 宽度
  //     labelCol: PropTypes.oneOf(range(1, 25)),
  //     // 定义 输入控件 宽度
  //     controlCol: PropTypes.oneOf(range(1, 25)),
  //     // 是否提供提交操作，若为 false，则不显示提交按钮，反之则显示。
  //     // 另外可以通过提供一个 Button 配置对象定义提交操作完成后的附加行为。
  //     submit: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  //     // 表单页脚配置
  //     footer: PropTypes.shape({
  //         className: PropTypes.string,
  //         style: PropTypes.object,
  //         row: PropTypes.object,
  //         col: PropTypes.object,
  //         // Button 配置对象数组
  //         items: PropTypes.array,
  //     }),
  // };


  function BasicForm(props) {
    var _this = _super.call(this, props) || this;

    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  BasicForm.prototype.componentWillMount = function () {
    var onInit = this.props.onInit;

    if (onInit) {
      onInit();
    }
  };
  /**
   * 表单提交事件处理函数
   */


  BasicForm.prototype.handleSubmit = function (event) {
    var _this = this;

    return new Promise(function (resolve) {
      if (_this.props.state.requestStatus === 'pending') {
        resolve(false);
      }

      if (event) {
        event.preventDefault();
      }

      _this.props.form.validateFields(function (err, _values) {
        if (err) {
          resolve(false);
        } else {
          var _a = _this.props,
              onSubmitStart = _a.onSubmitStart,
              onSubmit = _a.onSubmit;

          if (onSubmitStart) {
            onSubmitStart();
          }

          if (onSubmit) {
            onSubmit(event, _this.props.state.fields);
          }

          resolve(true);
        }
      });
    });
  };

  BasicForm.prototype.componentWillReceiveProps = function (nextProps) {
    var _this = this;

    var prevStatus = this.props.state.requestStatus;
    var nextStatus = nextProps.state.requestStatus;
    var _a = nextProps.state,
        fields = _a.fields,
        submitType = _a.submitType,
        onSubmitSuccess = nextProps.onSubmitSuccess,
        onSubmitError = nextProps.onSubmitError,
        submitSuccessBehavior = nextProps.submitSuccessBehavior,
        submitErrorBehavior = nextProps.submitErrorBehavior,
        onSubmitFinish = nextProps.onSubmitFinish,
        onReloadOptions = nextProps.onReloadOptions;

    if (submitType && prevStatus === 'pending' && nextStatus === 'success') {
      if (onSubmitSuccess) {
        onSubmitSuccess(nextProps.state.fields, submitType);
      }

      if (submitSuccessBehavior) {
        services.behaviorHandle(submitSuccessBehavior);
      }

      if (onSubmitFinish) {
        onSubmitFinish();
      }
    }

    if (submitType && prevStatus === 'pending' && nextStatus === 'error') {
      if (onSubmitError) {
        onSubmitError(nextProps.state.fields, submitType);
      }

      if (submitErrorBehavior) {
        services.behaviorHandle(submitErrorBehavior);
      }

      if (onSubmitFinish) {
        onSubmitFinish();
      }
    }

    var handleTriggerReload = function handleTriggerReload(oldField, newField) {
      var _a;

      if (newField.type === 'object.subForm') {
        forIn(newField.fields, function (field, name) {
          handleTriggerReload(get(oldField, 'fields', {})[name], field);
        });
      } else if (((_a = oldField) === null || _a === void 0 ? void 0 : _a.value) !== newField.value && newField.triggerOptionsReload && onReloadOptions) {
        for (var _i = 0, _b = newField.triggerOptionsReload; _i < _b.length; _i++) {
          var fieldName = _b[_i];
          onReloadOptions(fieldName, fields);
        }
      }
    };

    forIn(fields, function (field, name) {
      handleTriggerReload(get(_this.props, "state.fields." + name), field);
    });
  };

  BasicForm.prototype.render = function () {
    var _a = this.props,
        direction = _a.direction,
        className = _a.className,
        style = _a.style,
        showSpin = _a.showSpin,
        state = _a.state,
        fieldRow = _a.fieldRow;
    var formFields = this.renderFormFields(this.props.state.fields);
    var form = React.createElement(AntForm, {
      layout: direction,
      onSubmit: this.handleSubmit,
      className: className,
      style: style
    }, direction === 'inline' || !fieldRow ? formFields : React.createElement(AntRow, __assign({}, fieldRow), formFields), this.renderFormFooter());

    if (showSpin !== false) {
      var spinning = !!state && state.requestStatus === 'pending';
      return React.createElement(AntSpin, {
        spinning: spinning
      }, form);
    } else {
      return form;
    }
  };
  /**
   * 渲染表单域
   */


  BasicForm.prototype.renderFormFields = function (fields) {
    var _this = this;

    var _a = this.props,
        direction = _a.direction,
        fieldCol = _a.fieldCol;
    return map(fields, function (field, fieldname) {
      if (field.type === 'object.subForm') {
        return _this.renderSubForm(fieldname, field);
      } else {
        var item = _this.renderFormItem(fieldname, field);

        if (direction === 'inline' || !fieldCol) {
          return item;
        } else {
          return React.createElement(AntCol, __assign({}, fieldCol, {
            key: fieldname
          }), item);
        }
      }
    });
  };
  /**
   * 渲染子表单
   */


  BasicForm.prototype.renderSubForm = function (fieldname, field) {
    var _a = this.props,
        direction = _a.direction,
        fieldRow = _a.fieldRow;
    var formFields = this.renderFormFields(field.fields);

    if (direction === 'inline') {
      // 行内表单不添加子表单标题和缩进
      return formFields;
    } else {
      var label = field.displayName || fieldname;
      return React.createElement("fieldset", {
        className: "sub-form",
        key: fieldname
      }, React.createElement("legend", {
        className: "sub-form-title"
      }, cloneDeep(label)), fieldRow ? React.createElement(AntRow, __assign({}, fieldRow), formFields) : formFields);
    }
  };
  /**
   * 渲染表单项
   */


  BasicForm.prototype.renderFormItem = function (fieldname, field) {
    var type = field.type,
        className = field.className,
        colon = field.colon,
        extra = field.extra,
        hasFeedback = field.hasFeedback,
        labelAlign = field.labelAlign;
    var label = field.label || field.displayName || fieldname;
    var value = field.value; // 表单项设置

    var formItemProps = __assign({
      key: fieldname,
      //当有reactElement形式的label时，防止开发环境下报错
      label: cloneDeep(label),
      className: className,
      colon: colon,
      extra: extra,
      hasFeedback: hasFeedback,
      labelAlign: labelAlign
    }, this.getFormItemLayout()); // 渲染不可编辑域


    if (field.modifiable === false) {
      return React.createElement(AntForm.Item, __assign({}, formItemProps), TypesManager.get(type).getDisplayComponent(value, __assign(__assign({}, field.displayConfig), {
        name: field.name,
        options: field.options,
        row: this.props.state.fieldValues
      })));
    }

    var getFieldDecorator = this.props.form.getFieldDecorator;
    var validate = TypesManager.get(type).validate;
    var rules = field.rules || []; // 统一required校验失败message

    rules = rules.map(function (rule) {
      if (rule.required && !rule.message) {
        return __assign(__assign({}, rule), {
          message: "" + label + services.language.getText('components.Form.required')
        });
      }

      return rule;
    });
    return React.createElement(AntForm.Item, __assign({}, formItemProps), getFieldDecorator(fieldname, {
      rules: __spreadArrays(rules, [{
        validator: validate
      }]),
      initialValue: value
    })(this.renderFormControl(fieldname, field)));
  };
  /**
   * 渲染表单项中的输入组件
   */


  BasicForm.prototype.renderFormControl = function (fieldname, field) {
    var _a = this.props,
        entity = _a.entity,
        params = _a.params,
        fieldSource = _a.fieldSource;
    var type = field.type;

    var props = __assign(__assign({}, field.controlConfig), {
      name: fieldname,
      entity: entity,
      params: params,
      fieldSource: fieldSource,
      options: field.options,
      row: this.props.state.fieldValues
    });

    var control = TypesManager.get(type).getControlComponent(props);
    return control;
  };
  /**
   * 渲染表单页脚
   */


  BasicForm.prototype.renderFormFooter = function () {
    var _this = this;

    var _a = this.props,
        direction = _a.direction,
        submit = _a.submit,
        reset = _a.reset,
        footer = _a.footer,
        onReset = _a.onReset;

    var _b = footer || {},
        className = _b.className,
        style = _b.style,
        row = _b.row,
        col = _b.col,
        items = _b.items;

    var buttons = [];

    if (submit) {
      if (typeof submit !== 'object') {
        submit = {};
      }

      buttons.push(this.renderFooterButton(submit, 'footer-submit'));
    }

    if (reset) {
      if (typeof reset !== 'object') {
        reset = {};
      }

      reset = __assign({
        type: 'default',
        htmlType: 'button',
        text: services.language.getText('components.Button.reset'),
        onClick: onReset
      }, reset);
      buttons.push(this.renderFooterButton(reset, 'footer-reset'));
    }

    if (footer && items) {
      items.forEach(function (button, index) {
        buttons.push(_this.renderFooterButton(button, index));
      });
    }

    if (direction === 'inline') {
      return React.createElement(AntForm.Item, __assign({
        className: className,
        style: style
      }, this.getTailFormItemLayout()), buttons);
    } else {
      return React.createElement(AntRow, __assign({
        className: className,
        style: style
      }, row), React.createElement(AntCol, __assign({}, col), React.createElement(AntForm.Item, __assign({}, this.getTailFormItemLayout()), buttons)));
    }
  };

  BasicForm.prototype.renderFooterButton = function (props, key) {
    var btnProps = assign({}, {
      text: services.language.getText('components.Button.submit'),
      type: 'primary',
      htmlType: 'submit'
    }, props);
    return React.createElement(Button, __assign({}, btnProps, {
      key: key
    }));
  };
  /**
   * 获取表单项布局设置
   */


  BasicForm.prototype.getFormItemLayout = function () {
    var _a = this.props,
        direction = _a.direction,
        labelCol = _a.labelCol,
        controlCol = _a.controlCol;
    return direction === 'horizontal' ? {
      labelCol: {
        span: labelCol
      },
      wrapperCol: {
        span: controlCol || GRID_COLUMN_NUMBER - labelCol
      }
    } : undefined;
  };
  /**
   * 获取尾部表单项布局设置
   */


  BasicForm.prototype.getTailFormItemLayout = function () {
    var _a = this.props,
        direction = _a.direction,
        labelCol = _a.labelCol,
        controlCol = _a.controlCol;
    return direction === 'horizontal' ? {
      wrapperCol: {
        offset: labelCol,
        span: controlCol || GRID_COLUMN_NUMBER - labelCol
      }
    } : undefined;
  };

  BasicForm.defaultProps = {
    direction: 'horizontal',
    labelCol: 8
  };
  return BasicForm;
}(Component);

export { BasicForm };
export var Form = AntForm.create({
  mapPropsToFields: function mapPropsToFields(props) {
    return function generateFields(source) {
      var fields = {};
      forIn(source, function (field, name) {
        if (field.type === 'object.subForm') {
          Object.assign(fields, generateFields(field.fields));
        } else {
          fields[name] = AntForm.createFormField(__assign(__assign({}, field.status), {
            value: field.value
          }));
        }
      });
      return fields;
    }(props.state.fields);
  },
  onFieldsChange: function onFieldsChange(props, changedFields) {
    var fields = props.state.fields,
        onFieldStatusChange = props.onFieldStatusChange;

    if (onFieldStatusChange) {
      (function handleFieldsChange(fields, changedFields, prefix) {
        forIn(changedFields, function (changedField, name) {
          var fieldName = prefix + name;
          var field = fields[fieldName];

          if (field.type === 'object.subForm') {
            handleFieldsChange(field.fields, changedField, fieldName + '.');
          } else {
            var value = changedField.value,
                status_1 = __rest(changedField, ["value"]);

            onFieldStatusChange(fieldName, status_1);
          }
        });
      })(fields, changedFields, '');
    }
  },
  onValuesChange: function onValuesChange(props, changedValues) {
    var fields = props.state.fields,
        onFieldChange = props.onFieldChange;

    if (onFieldChange) {
      (function handleValuesChange(fields, changedValues, prefix) {
        forIn(changedValues, function (changedValue, name) {
          var fieldName = prefix + name;
          var field = fields[fieldName];

          if (field.type === 'object.subForm') {
            handleValuesChange(field.fields, changedValue, fieldName + '.');
          } else {
            onFieldChange(fieldName, changedValue);
          }
        });
      })(fields, changedValues, '');
    }
  }
})(BasicForm);